const site = {
  brand: "Atlas Brokerage",
  domain: "atlas-brokerage.com",
  tagline: "Engineered Technology for Businesses That Refuse to Stand Still.",
  shortPitch:
    "We design, build and operate the technology backbone behind modern enterprises — software, networks, cloud and security, delivered as one cohesive practice.",
  location: {
    city: "Sofia",
    country: "Bulgaria",
    region: "European Union",
    address: {
      line1: "9 Pozitano Street, Floor 1, Shop 15",
      line2: "Triaditsa Region, Stolichna Municipality",
      city: "Sofia 1000",
      country: "Bulgaria"
    }
  },
  contact: {
    email: "info@atlas-brokerage.com"
  },
  stats: [
    { value: "120+", label: "Enterprise engagements delivered" },
    { value: "14", label: "Industries served across EU & MEA" },
    { value: "99.98%", label: "Average managed-service uptime" },
    { value: "24 / 7", label: "Network operations coverage" }
  ],
  industries: [
    "Financial Services",
    "Logistics & Trade",
    "Real Estate & Construction",
    "Hospitality",
    "Healthcare",
    "Retail & E-commerce",
    "Manufacturing",
    "Public Sector"
  ]
};

export default site;
